module.exports = __webpack_public_path__ + "img/product-icon_3.fa41c53d.png";